if (!customElements.get('scroll-to-top-button')) {
  class ScrollToTopButton extends HTMLElement {
    constructor() {
      super();
      this.isRevealed = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.onClickHandler = this.scrollToTop.bind(this);
      this.onKeyDownHandler = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      // Initial state
      this.updateVisibility();

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.addEventListener('click', this.onClickHandler);
      this.addEventListener('keydown', this.onKeyDownHandler);

      // Widget-urile de chat terte (Gorgias etc.) se pozitioneaza tot jos-dreapta si isi
      // termina randarea asincron; recalculam distanta cateva ori dupa incarcare, apoi la
      // fiecare redimensionare.
      this.onResizeHandler = () => this.avoidChatWidget();
      window.addEventListener('resize', this.onResizeHandler);
      [500, 1500, 3000, 6000].forEach((delay) => setTimeout(() => this.avoidChatWidget(), delay));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      this.removeEventListener('click', this.onClickHandler);
      this.removeEventListener('keydown', this.onKeyDownHandler);
    }

    avoidChatWidget() {
      if (!this.classList.contains('bottom-right')) return;

      // Cautam doar iconita mica a lansatorului (ex. iframe#chat-button la Gorgias), nu si
      // panoul de conversatie extins, care sta tot fixed/z-index mare dar e mult mai mare
      // chiar si cand e ascuns (opacity: 0).
      let widgetTop = null;
      document.querySelectorAll('body *').forEach((el) => {
        if (el === this || this.contains(el)) return;
        const style = getComputedStyle(el);
        if (style.position !== 'fixed') return;
        if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) return;
        const z = parseInt(style.zIndex, 10);
        if (!(z > 100000)) return;
        const rect = el.getBoundingClientRect();
        if (rect.width < 20 || rect.height < 20) return;
        if (rect.width > 150 || rect.height > 150) return;
        if (rect.right < window.innerWidth - 200) return;
        if (rect.bottom < window.innerHeight - 200) return;
        if (widgetTop === null || rect.top < widgetTop) widgetTop = rect.top;
      });

      if (widgetTop === null) {
        this.style.removeProperty('--chat-widget-clear');
        return;
      }
      const gap = 12;
      this.style.setProperty('--chat-widget-clear', `${Math.round(window.innerHeight - widgetTop + gap)}px`);
    }

    onScroll() {
      // Schedule all DOM reads/writes in one animation frame
      if (this._ticking) return;
      this._ticking = true;

      requestAnimationFrame(() => {
        this._ticking = false;
        this.updateVisibility();
      });
    }

    updateVisibility() {
      // Read scroll position once per frame, not on every event
      const shouldReveal = window.scrollY > window.innerHeight;
      if (shouldReveal !== this.isRevealed) {
        this.isRevealed = shouldReveal;
        this.classList.toggle('reveal', shouldReveal);
      }
    }

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // Wait until scroll completes before focusing (simple heuristic)
      setTimeout(() => {
        document.querySelector('.skip-to-content-link')?.focus();
      }, 700);
    }

    onKeyDown(event) {
      if (event.key === 'Enter') {
        this.scrollToTop();
      }
    }
  }

  customElements.define('scroll-to-top-button', ScrollToTopButton);
}